import React, { useState, useEffect } from 'react';
import { SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from 'swiper';
import BannerSliderItem, {
  BannerSliderItemProps,
} from './_bannerslider-item';
import clsx from 'clsx';
import { Swiper } from 'swiper/react';

interface BannerSliderBlockProps {
  systemId: string;
  fullwidth: boolean;
  slides: BannerSliderItemProps[];
}

const BannerSliderBlock = (props: BannerSliderBlockProps) => {
  const { slides, systemId, fullwidth } = props;

  const [ready, setReady] = useState(false);
  const firstSlide: BannerSliderItemProps | undefined = slides[0];

  useEffect(() => setReady(slides.length != 1), [slides]);

  return slides?.length > 0 ? (
    <div
      className={clsx(
        'container overflow-x-hidden md-down:px-0',
        fullwidth && 'px-0 max-w-none'
      )}
    >
      {!ready && !!firstSlide && <BannerSliderItem {...firstSlide} />}
      {ready && (
        <Swiper
          className={clsx('banner-swiper')}
          pagination={true}
          navigation={true}
          modules={[Pagination, Navigation]}
          lazy={true}
          loop={true}
        >
          {slides.map((slide: BannerSliderItemProps, index: number) => (
            <SwiperSlide key={'banner-slider' + index + systemId}>
              <BannerSliderItem {...slide} />
            </SwiperSlide>
          ))}
        </Swiper>
      )}
    </div>
  ) : (
    <></>
  );
};

export default BannerSliderBlock;
